import React from "react";
import "./ProjectLogo.css";

// Gradient pairs chosen to sit well beside the navy/gold brand palette.
const PALETTE = [
  ["#2b72ab", "#123452"], // navy
  ["#e0b54a", "#a8780f"], // gold
  ["#22a06b", "#0f5e3d"], // emerald
  ["#8a5cc7", "#4b2a80"], // plum
  ["#2aa3a3", "#135f63"], // teal
  ["#d0674a", "#8c3420"], // terracotta
  ["#5b6b82", "#2c3645"], // slate
  ["#b24a73", "#6d1f40"], // burgundy
];

// The original four use gradients of their chart colours (Overview charts),
// so a project's mark matches its bars and legend swatch everywhere.
const FIXED = {
  "vatika seven elements": ["#4a92e6", "#1c5cab"], // chart blue
  "sovereign park": ["#f28a60", "#c4501f"], // chart orange
  "saan verdante": ["#2cc592", "#11805a"], // chart aqua
  "inframantra ho": ["#f2b63a", "#b97f00"], // chart yellow
};

const hash = (text) =>
  [...text].reduce((acc, char) => (acc * 31 + char.charCodeAt(0)) >>> 0, 7);

export const projectInitials = (name = "") => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  const first = words[0][0];
  const second = words.length > 1 ? words[1][0] : words[0][1] || "";
  return (first + second).toUpperCase();
};

// Monogram "logo" for a project: initials on a gradient derived from the
// name, so every project gets a stable, distinct mark with no upload needed.
const ProjectLogo = ({ name = "", size = 36, className = "" }) => {
  const key = name.trim().toLowerCase();
  const [from, to] = FIXED[key] || PALETTE[hash(key) % PALETTE.length];
  return (
    <span
      className={`project-logo ${className}`.trim()}
      style={{
        "--pl-from": from,
        "--pl-to": to,
        width: size,
        height: size,
        fontSize: Math.round(size * 0.38),
      }}
      aria-hidden="true"
    >
      {projectInitials(name)}
    </span>
  );
};

export default ProjectLogo;
